export enum DeviceTypeEnum {
  DESKTOP = 'desktop'
}
